
module.exports = { 
      attributes: {"title":"footer","logoFooter":"/img/no-image.jpg","addressFooter":"12, Rue   \nquartier,  \n98800 Nouméa","phoneFooter":"(+687) 00 00 00","mailFooter":"mail@mail.nc"},
    
      html: "",
     }